import http from "../http-common-2";


class UserDataService {
  getUserJourney(sortBy: any, level: any, page: any, pageSize: any) {
    return http.get(
      `/user-journey?sortBy=${sortBy}&level=${level}&page=${page}&pageSize=${pageSize}`
    );
  }

  getUserIdsByLevel(level: any,subLevel:any,accesscode:any) {
    return http.get(
      `/userids?level=${level}&sublevel=${subLevel}&accesscode=${accesscode}`
    );
  }

  getUserMonthlyData(type:any) {
    return http.get(`users/count/monthlydata?type=${type}`);
  }

  getUserIdsByAdvanceFilter(age: any,gender:any) {
    return http.get(
      `/userids/advance?age=${age}&gender=${gender}`
    );
  }

  activatePro(id:any,period: any,module:any) {
    return http.get(
      `/users/${id}/updatemanoshalapro/?period=${period}&module=${module}&paymentId=none&paymentAmount=0`
    );
  }
}

export default new UserDataService();
